import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FitbitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fitbit"}/>
}
